import MoreAssets from "../../component/moreAssets/MoreAssets";
import { useTranslation } from "react-i18next";

export default function CompliancePage() {
	const { t } = useTranslation();
	return <MoreAssets title={t("MAP AND SURE")} dataKey={'mapAndSureDetails'}/>
}

